import React from "react";
import { PageWrapper } from "components/pages";
import { EditRepDetails } from "features/EditRepDetails";

const RepDetailsPage = () => {
  return (
    <PageWrapper>
      <EditRepDetails />
    </PageWrapper>
  );
};

export default RepDetailsPage;
